import React from 'react';
import { StyledHeader } from './Header.styles';
import Button from '../Button';
import { useNavigate, useLocation } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../context/authContext';
import { Sparkles } from 'lucide-react';

const PAGE_TITLES = {
  '/dashboard': { title: 'Dashboard', subtitle: 'Start a conversation or pick up where you left off' },
  '/get-started': { title: 'Get Started', subtitle: 'Set up your football intelligence workspace' },
  '/agents': { title: 'Agents', subtitle: 'Browse and manage your AI agents' },
  '/create-agent': { title: 'Create Agent', subtitle: 'Build a custom football intelligence agent' },
  '/projects': { title: 'Projects', subtitle: 'Organise research and chat threads' },
  '/team': { title: 'Team', subtitle: 'Collaborate with your organisation' },
  '/tools': { title: 'Tools', subtitle: 'Connect integrations and capabilities' },
  '/workflows': { title: 'Workflows', subtitle: 'Automate multi-step intelligence flows' },
  '/task-manager': { title: 'Task Manager', subtitle: 'Schedule and monitor agent tasks' },
  '/analytics': { title: 'Analytics', subtitle: 'Track usage and performance' },
  '/settings': { title: 'Settings', subtitle: 'Manage your account and preferences' },
};

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContextHook(AuthContext, v => ({ user: v.user }));

  const page = PAGE_TITLES[location.pathname] || {
    title: 'InterFCP',
    subtitle: 'Football intelligence platform',
  };

  return (
    <StyledHeader>
      <div className="header-left">
        <span className="greeting">
          {user?.first_name ? `Welcome back, ${user.first_name}` : 'Welcome back'}
        </span>
        <h1 className="page-title">{page.title}</h1>
        <p className="page-subtitle">{page.subtitle}</p>
      </div>
      <div className="header-actions">
        <button type="button" className="help-chip" onClick={() => navigate('/agents')}>
          <Sparkles size={16} />
          <span>Explore agents</span>
        </button>
        <Button variant="primary" width="140px" onClick={() => navigate('/upgrade-plan')}>
          Upgrade Plan
        </Button>
      </div>
    </StyledHeader>
  );
};

export default Header;
